import React from 'react'
import type { PeriodComparisonMetric } from '@services/api/dashboard/finance.api'
import {
  buildComparisonFooter,
  type ComparisonFooter,
} from '@utils/dashboardFinance.util'

export function ComparisonMetricFooter({
  up,
  text,
}: ComparisonFooter): React.ReactElement {
  return (
    <>
      <i
        className={
          up ? 'mgc mgc_arrow_up_circle_fill' : 'mgc mgc_arrow_down_circle_fill'
        }
        aria-hidden
      />
      <span>{text}</span>
    </>
  )
}

export function dashboardFinanceMetricFooter(
  metric: PeriodComparisonMetric,
  options?: { isCurrency?: boolean; isCount?: boolean },
): React.ReactNode {
  const { up, text } = buildComparisonFooter(metric, options)
  return (
    <>
      <i
        className={
          up ? 'mgc mgc_arrow_up_circle_fill' : 'mgc mgc_arrow_down_circle_fill'
        }
        aria-hidden
      />
      <span>{text}</span>
    </>
  )
}
